export default function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-espresso text-cream pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16 border-b border-cream/15">
          <div className="md:col-span-6">
            <div className="text-xs tracking-[0.3em] uppercase text-brass mb-4">AKT Global Enterprises LLC</div>
            <p className="font-serif text-2xl md:text-3xl leading-snug max-w-xl text-cream/90 font-light">
              A boutique short-term rental management firm &mdash; elevating homes,
              delighting guests, and multiplying returns.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-cream/60 mb-4">Navigate</div>
            <ul className="space-y-3 text-sm text-cream/90">
              <li><a href="#about" className="hover:text-brass transition-colors">About</a></li>
              <li><a href="#services" className="hover:text-brass transition-colors">Services</a></li>
              <li><a href="#portfolio" className="hover:text-brass transition-colors">Portfolio</a></li>
              <li><a href="#faq" className="hover:text-brass transition-colors">FAQ</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-cream/60 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-cream/90">
              <li>Angelique@aktglobalenterprises.com</li>
              <li>Select metro &amp; coastal markets</li>
              <li>Mon &ndash; Fri · 24/7 guest support</li>
            </ul>
          </div>
        </div>

        <div
          aria-hidden="true"
          className="font-serif text-cream/10 leading-none tracking-tighter select-none text-[26vw] md:text-[18vw] lg:text-[14vw] mt-10"
        >
          AKT GLOBAL
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mt-6 text-[11px] tracking-[0.2em] uppercase text-cream/50">
          <div>© {new Date().getFullYear()} AKT Global Enterprises LLC. All rights reserved.</div>
          <div>Crafted with care · Short-Term Rental Management</div>
        </div>
      </div>
    </footer>
  );
}
